import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Tab, Tabs } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

import { getAvailableModules } from '../modules';
import PlatformPropertySelector from './PlatformPropertySelector';


function resolveActiveTab(pathname, items) {
  if (pathname === '/') {
    return '/';
  }

  const activeItem = items.find((item) => (
    item.path !== '/' && (pathname === item.path || pathname.startsWith(`${item.path}/`))
  ));

  return activeItem?.path || false;
}


export default function PlatformSubheader() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = useSelector((state) => state.user.user);
  const modules = getAvailableModules(currentUser);

  const items = React.useMemo(() => ([
    { key: 'home', label: 'Home', path: '/', icon: HomeOutlinedIcon },
    ...modules.map((module) => ({
      key: module.key,
      label: module.label,
      path: module.workspacePath,
      icon: module.icon,
    })),
  ]), [modules]);

  const activeTab = resolveActiveTab(location.pathname, items);

  return (
    <Box
      sx={{
        borderTop: 1,
        borderColor: 'divider',
        py: 1.25,
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) auto' },
          gap: 2,
          alignItems: 'end',
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(_, value) => navigate(value)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="platform navigation"
          sx={{
            minHeight: 58,
            '& .MuiTab-root': {
              minHeight: 58,
              minWidth: 'fit-content',
              px: 2,
              textTransform: 'none',
              fontWeight: 700,
              color: 'text.secondary',
              borderBottom: '2px solid transparent',
            },
            '& .MuiTab-root.Mui-selected': {
              color: 'text.primary',
            },
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: '3px 3px 0 0',
              backgroundColor: 'secondary.main',
            },
          }}
        >
          {items.map((item) => (
            <Tab
              key={item.key}
              value={item.path}
              icon={React.createElement(item.icon, { fontSize: 'small' })}
              iconPosition="start"
              label={item.label}
            />
          ))}
        </Tabs>

        <PlatformPropertySelector />
      </Box>
    </Box>
  );
}